import { useUpdateUserExpiryDate } from '@streamster/shared/api/api.portal';
import mixins from '@streamster/shared/app/styles';
import Button from '@streamster/shared/components/Button/Button';
import DefaultModal from '@streamster/shared/components/DefaultModal/DefaultModal';
import Heading from '#/components/Heading/Heading';
import { Paragraph } from '#/components/Typography/Typography';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import styles from './DetailsBox.module.scss';

type Props = { data: any };

export const DetailsBox: React.FC<Props> = ({ data }) => {
  const { tariffValidTo, type, registeredAt, willRenew, email, tariffName, paymentByBalance } =
    data;

  const [updateExpiryModalVisible, setUpdateExpiryModalVisibility] = useState(false);
  const [expiryDate, setExpiryDate] = useState(dayjs(tariffValidTo).format('YYYY-MM-DD'));
  const { mutateAsync, isPending } = useUpdateUserExpiryDate();

  return (
    <>
      <div className={styles.wrapper}>
        <Heading variant="subSection">Detals</Heading>
        <div className={styles.details}>
          <div className={styles.item}>
            <strong>Email</strong>
            <span>{email}</span>
          </div>
          <div className={styles.item}>
            <strong>Registered</strong>
            <span>{dayjs(registeredAt).format('DD/MM/YYYY')}</span>
          </div>
          <div className={styles.item}>
            <strong>User type</strong>
            <span>{type}</span>
          </div>
          {tariffName && (
            <div className={styles.item}>
              <strong>Tariff</strong>
              <span>{tariffName}</span>
            </div>
          )}
          {willRenew !== undefined && (
            <div className={styles.item}>
              <strong>Will renew tariff</strong>
              <span>{paymentByBalance ? 'Yes' : 'No'}</span>
            </div>
          )}
          {tariffValidTo && (
            <>
              <div className={styles.item}>
                <strong>Tariff valid to</strong>
                <span>
                  <div>{dayjs(tariffValidTo).format('DD/MM/YYYY')}</div>
                  <Button
                    secondary
                    disabled={!paymentByBalance}
                    onPress={() => setUpdateExpiryModalVisibility(true)}
                  >
                    Change expiry date
                  </Button>
                </span>
              </div>
              <div className={styles.item}>
                <strong>Payment by user balance</strong>
                <span>{paymentByBalance ? 'Yes' : 'No'}</span>
              </div>
            </>
          )}
        </div>
      </div>
      {updateExpiryModalVisible && (
        <DefaultModal
          title="Choose new expire date"
          onDismiss={() => setUpdateExpiryModalVisibility(false)}
          confirmLoading={isPending}
          confirmText="Change expiry date"
          onConfirm={async () => {
            await mutateAsync({ id: data.id, validTo: dayjs(expiryDate).endOf('day').toDate() });
            setUpdateExpiryModalVisibility(false);
          }}
        >
          <Paragraph style={mixins().styles.margin.bottomI6}>Choose new date</Paragraph>
          <input
            type="date"
            min={dayjs().format('YYYY-MM-DD')}
            onChange={e => setExpiryDate(e.target.value)}
            value={expiryDate}
          />
        </DefaultModal>
      )}
    </>
  );
};
